import { HttpBackend } from '@angular/common/http'
import { importProvidersFrom } from '@angular/core'

import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader'

import { TranslateLoader, TranslateModule } from '@ngx-translate/core'

import { getBuildId } from './build-id'

export const httpTranslateLoader = (http: HttpBackend) => {
  // Translation files are copied verbatim by the build, so their names are stable across
  // deployments. Without a build-specific query string a browser (or any intermediary cache)
  // can serve a translation file that predates the keys the new bundle expects, which shows up
  // as raw keys or a mixed-language screen. See issue #1035.
  const suffix = `.json?v=${encodeURIComponent(getBuildId())}`

  return new MultiTranslateHttpLoader(http, [
    { prefix: '/assets/yoshu-lib/i18n/', suffix },
    { prefix: '/assets/i18n/', suffix }
  ])
}

/**
 * Provides the translation module configuration for the application.
 *
 * This function sets up the `TranslateModule` with a custom loader and a default language.
 * It uses the `httpTranslateLoader` function as the factory for the `TranslateLoader`,
 * which depends on the `HttpClient` service.
 *
 * @returns The providers for the `TranslateModule` configured with the specified loader and default language.
 */
export const provideTranslate = () => {
  return importProvidersFrom(
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpBackend]
      },
      fallbackLang: 'en'
    })
  )
}
